export enum MatchStatusEnum {
  PENDING = 'pending',
  LIVE = 'live',
  ENDED = 'ended',
}
